import { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://backend.smpn1kamal.sch.id/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Masuk gagal");
        return;
      }

      login(data.user, data.token);

      switch (data.user.role) {
        case "admin":
          navigate("/admin");
          break;
        case "guru":
          navigate("/guru");
          break;
        case "pimpinan":
          navigate("/pimpinan");
          break;
        default:
          setError("Role tidak dikenali");
      }
    } catch {
      setError("Server tidak bisa diakses");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* HEADER */}
      <header className="bg-white shadow px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-blue-700">SIPENSA</h1>
        <Link
          to="/register-guru"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
        >
          Daftar
        </Link>
      </header>

      <main className="flex flex-1 items-center justify-center px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl w-full">
          {/* KIRI */}
          <div className="flex flex-col justify-center items-center md:items-start">
            <img src="/logo.png" alt="Logo" className="w-32 mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold">Selamat Datang</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-blue-600 mt-2">
              Di SIPENSA
            </h3>
            <p className="text-gray-600 mt-4 max-w-sm">
              Silakan masuk menggunakan akun yang telah terdaftar.
            </p>
          </div>

          {/* FORM LOGIN */}
          <div className="bg-white p-8 rounded-xl shadow w-full max-w-sm">
            <h1 className="text-xl font-bold text-center mb-6">Masuk</h1>

            <form onSubmit={handleLogin}>
              <label className="block mb-2 text-sm">Username</label>
              <input
                className="w-full border rounded px-4 py-2 mb-4"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />

              <label className="block mb-2 text-sm">Kata Sandi</label>
              <div className="relative mb-2">
                <input
                  type={showPassword ? "text" : "password"}
                  className="w-full border rounded px-4 py-2 pr-10"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (e.target.value === "") setShowPassword(false);
                  }}
                  autoComplete="current-password"
                  required
                />
                {password.length > 0 && (
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    tabIndex={-1}
                    aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
                  >
                    {showPassword ? (
                      // Mata TERBUKA — password sedang terlihat
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    ) : (
                      // Mata TERTUTUP — password tersembunyi (default)
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                    )}
                  </button>
                )}
              </div>

              <div className="flex justify-end mb-4">
                <Link
                  to="/request-reset-password"
                  className="text-sm text-blue-600 hover:underline"
                >
                  Lupa kata sandi?
                </Link>
              </div>

              {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

              <button
                type="submit"
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 w-full"
              >
                Masuk
              </button>

              <p className="text-center text-sm mt-4">
                Belum punya akun?{" "}
                <Link to="/register-guru" className="text-blue-600 hover:underline">
                  Daftar
                </Link>
              </p>
            </form>
          </div>
        </div>
      </main>

      <footer className="text-center py-4 text-sm text-gray-600">
        Sistem Informasi Presensi SMPN 1 Kamal
      </footer>
    </div>
  );
}